import { call, type CallEffect, put, type PutEffect, takeLatest } from 'redux-saga/effects'
import { type AnyAction } from 'redux'

import DashboardService from '@api/DashboardService'
import { getEnvelops, getEnvelopsSuccess, getEnvelopsFailure } from '@store/slices/Dashboard.slice'
import { type DashboardResponseType } from '@app-types/DashboardTypes'

function* watchGetEnvelops(
    action: ReturnType<typeof getEnvelops>
): Generator<CallEffect<DashboardResponseType> | PutEffect<AnyAction>, void, DashboardResponseType> {
    try {
        const response = yield call(DashboardService.getEnvelops)
        yield put(getEnvelopsSuccess(response))
    } catch (error) {
        yield put(getEnvelopsFailure(error))
    }
}

const dashboardSaga = [takeLatest(getEnvelops, watchGetEnvelops)]

export default dashboardSaga
